import type { AuthStoreState } from "./types";
import { ProductTypes, Store } from "~/types";

export const state = (): AuthStoreState => ({
  authenticated: false,
  user: {
    email: "",
    username: "",
    emailVerified: false,
    mobileVerified: false,
    notificationsEnabled: false,
    updatedAt: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
    subscriberID: "",
    address: "",
    city: "",
    state: "",
    postalCode: "",
    dateOfBirth: "",
  },
  subscription: {
    interval: ProductTypes.NONE,
    store: Store.NONE,
  },
});
